import { useEffect, useState } from 'react';
import { useReducedMotion } from 'framer-motion';

/** Anima um número de 0 → target via rAF com easeOutCubic.
 *  Respeita prefers-reduced-motion (retorna target imediatamente).
 *  Brief §10 — usado nos cards KPI da Home. */
export function useCountUp(target: number, duration = 800): number {
  const reduce = useReducedMotion();
  const [value, setValue] = useState<number>(reduce ? target : 0);

  useEffect(() => {
    if (reduce) {
      setValue(target);
      return;
    }
    let raf = 0;
    const startTime = performance.now();
    const easeOutCubic = (t: number) => 1 - Math.pow(1 - t, 3);

    function tick(now: number) {
      const elapsed = now - startTime;
      const progress = Math.min(1, elapsed / duration);
      setValue(Math.round(target * easeOutCubic(progress)));
      if (progress < 1) raf = requestAnimationFrame(tick);
    }

    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, duration, reduce]);

  return value;
}
